import { useTranslation } from 'react-i18next';

import { useConfirmPopup } from 'components/popups/useConfirmPopup';
import { useVerifyPhonePopup } from 'features/account/verify-phone/useVerifyPhonePopup';
import { usePopup } from 'hooks/usePopup';
import { userService } from 'services/user/userService';
import { CurrentUserDto } from 'services/user/userService.dto';

import BecomeFundraiserForm from './BecomeFundraiserForm';

export const useBecomeFundraiserPopup = () => {
  const { t } = useTranslation('myProfile');
  const { showPopup, hidePopup } = usePopup();
  const { showConfirmPopup } = useConfirmPopup();
  const { showVerifyPhonePopup } = useVerifyPhonePopup();

  const handleClose = () => showConfirmPopup({ msg: t('become-fundraiser.quit-form-msg'), onYes: hidePopup });

  const showBecomeFundraiserPopup = async (user: CurrentUserDto) => {
    if (!user.ableToBecomeFundraiser) return;

    const fundraiserData = await resolveFundraiserData(user);
    const startBecomeFundraiserFlow = () =>
      showPopup(<BecomeFundraiserForm user={user} fundraiserData={fundraiserData} />, {
        onClose: handleClose,
        paddingVariant: 'FORM',
      });
    if (!user.phoneVerified) showVerifyPhonePopup(startBecomeFundraiserFlow);
    else startBecomeFundraiserFlow();
  };

  const resolveFundraiserData = async (user: CurrentUserDto) => {
    if (user.fundraiserType && user.ableToCreateCampaigns) {
      try {
        const { data: fundraiserData } = await userService.fetchFundraiserDetails();
        return fundraiserData;
      } catch (e) {
        return undefined;
      }
    } else return undefined;
  };

  return { showBecomeFundraiserPopup };
};
